<form [formGroup]="profileForm" class="profile-content-layout">
  <mat-form-field>
    <mat-label>Name</mat-label>
    <input matInput type="text" formControlName="companyName" />
    <mat-error>Company name is required</mat-error>
  </mat-form-field>
  <mat-form-field>
    <mat-label>Website</mat-label>
    <input matInput type="text" formControlName="companyWebsite" />
  </mat-form-field>
  <tix-checkbox [labelPosition]="'before'" [formControl]="isDefaultCompany">
    Set this company as my default upon login
  </tix-checkbox>
</form>
<!-- <a class="mt-4" tix-flat-border-button href="#"><tix-icon svgIcon="plus-sm"></tix-icon>Add Company Logo</a> -->

<div class="flex flex-col sm:flex-row gap-3 sm:gap-4 mt-6 justify-end">
  <button
    tix-flat-border-button
    color="danger"
    class="w-full sm:w-auto px-6 py-1.5 sm:py-1 text-sm font-medium order-2 sm:order-1"
    (click)="deleteEvent()"
    *ngIf="companyId"
  >
    Delete Company
  </button>
  <button
    mat-button
    (click)="onSave()"
    class="w-full sm:w-auto min-w-[160px] px-6 py-1.5 sm:py-1 bg-primary text-white font-medium order-1 sm:order-2"
    [ngClass]="[
      pristineOrInvalid ? 'cursor-not-allowed' : 'cursor-pointer',
      pristineOrInvalid && !isloading
        ? 'hover:bg-gray-300 hover:text-gray-700 hover:opacity-50'
        : 'hover:bg-primary-700'
    ]"
    [disabled]="pristineOrInvalid"
  >
    <div *ngIf="!isloading" class="flex items-center justify-center">
      <span class="material-icons-outlined mr-2 text-lg">save</span>
      <span>Save Changes</span>
    </div>
    <div *ngIf="isloading" class="flex items-center justify-center space-x-2">
      <span class="mr-2" *tixBtnLoading="isloading"></span>
      <span>Loading</span>
    </div>
  </button>
</div>
